module.exports = __webpack_public_path__ + "static/media/RFIDIcon.41f1303a.svg";